import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Button, Card, Elevation } from "@blueprintjs/core";

@withRouter
@inject("store")
@observer
export default class CourseCard extends Component
{
    // constructor(props) 
    // {
    //     super(props);
    // }
    
    // componentDidMount()
    // {
    //    // 
    // }

    // componentDidUpdate(prevProps)
    // {
    //     if (this.props.data !== prevProps.data) 
    //     {
           
    //     }
    // }
    go()
    {
        const url = this.props.url || "/course/detail/"+this.props.data.id;
        if( this.props.url )
        {
            this.props.history.push(this.props.url);
        }
        else
        {
            window.open( url,"_blank");
        }
        
        
    }
    
    render()
    {
        
        
        return this.props.data ? <Card className="course-card" interactive={true} elevation={Elevation.TWO} onClick={()=>this.go()}>
        <div className={"cover ft-bg-"+this.props.data.color}>
            <img src={this.props.data.cover_url} alt={this.props.data.title}/>
        </div>
        <div className="content">
        <div className="title">{this.props.data.title}</div>
        <div className="subtitle">{this.props.data.subtitle}</div>
        </div>
        <div className="actionbar">
            <div className="left">
            { this.props.show_price ? <del>¥{(this.props.data.price_cent/100).toFixed(2)}</del> : this.props.action || "开始学习"  }
            {this.props.data.wanmian_days > 0 ? <span className={"badge ml-1 ft-bg-"+this.props.data.color}>学完免费</span> : <span className={"badge ml-1 ft-bg-"+this.props.data.color}>订阅后免费</span> }
                
            </div>
            <div className="right">{this.props.data.author.nickname}主讲 {this.props.data.is_ai_voice > 0 ? '🤖AI转述' : ''}</div>
        </div>
    
    </Card>: null;
    }
}